<template>
  <div id="app">
    <index v-if="!(path ==='/login/index')"></index>
    <router-view :key="$route.fullPath" />
    <!-- <footer></footer> -->
  </div>
</template>

<script>
// import index_css from "../static/font/element-icons.eot";
import index from "./components/index/main-menu";
// import footer from "./components/footer/index";
export default {
  name: "App",
  data() {
    return {
      path: ""
    };
  },
  components: { index },
  watch: {
    $route(to, from) {
      this.path = to.path;
    }
  },
  mounted() {
    this.path = this.$route.path;
    this.view();
    window.addEventListener("beforeunload", this.saveCurrentUser());
    // window.onbeforeunload = function(e) {
    //   window.sessionStorage.clear();
    // };
  },
  methods: {
    view() {
      if (this.$store.state.currentUser == "") {
        this.$axios({
          method: "post",
          url: "/index/login/out"
        })
          .then(res => {})
          .catch(err => {});
      }
    },
    saveCurrentUser() {
      sessionStorage.setItem("user", this.$store.state.currentUser);
      sessionStorage.setItem("qty", this.$store.state.currentQty);
    }
  }
};
</script> 
<style>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
  color: #2c3e50; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue